import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Fancybox } from "@fancyapps/ui";

import "swiper/css";
import "swiper/css/navigation";
import "@fancyapps/ui/dist/fancybox.css";
import "../../css/btmgallery.css";

const galleryItems = [
  { img: "/img/gallery/2.png", full: "/img/gallery/photos/02.jpeg" },
  { img: "/img/gallery/3.png", full: "/img/gallery/photos/03.jpeg" },
  { img: "/img/gallery/4.png", full: "/img/gallery/photos/04.jpeg" },
  { img: "/img/gallery/5.png", full: "/img/gallery/photos/05.jpeg" },
  { img: "/img/gallery/6.png", full: "/img/gallery/photos/06.jpeg" },
  { img: "/img/gallery/7.png", full: "/img/gallery/photos/07.jpeg" },
  { img: "/img/gallery/8.png", full: "/img/gallery/photos/08.jpeg" },
  { img: "/img/gallery/9.png", full: "/img/gallery/photos/09.jpeg" },
  { img: "/img/gallery/10.png", full: "/img/gallery/photos/10.jpeg" },
  { img: "/img/gallery/11.png", full: "/img/gallery/photos/11.jpeg" },
  { img: "/img/gallery/12.png", full: "/img/gallery/photos/12.jpeg" },
  { img: "/img/gallery/13.png", full: "/img/gallery/photos/13.jpeg" },
  { img: "/img/gallery/14.png", full: "/img/gallery/photos/14.jpeg" },
];

export default function GallerySlider() {
  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: true,
      Toolbar: true,
      animated: true,
    });
  }, []);

  return (
    <div className="section">
      <Swiper
        spaceBetween={0}
        slidesPerView={4}
        loop={true}
        autoplay={{ delay: 2500 }}
        navigation={true}
        modules={[Autoplay, Navigation]}
        breakpoints={{
          0: { slidesPerView: 2 },
          576: { slidesPerView: 3 },
          992: { slidesPerView: 4 },
        }}
        className="gallery-swiper"
      >
        {galleryItems.map((item, i) => (
          <SwiperSlide key={i}>
            <a data-fancybox="gallery" href={item.full}>
              <div className="img-wrap gallery-small">
                <img src={item.img} alt="" />
              </div>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
